module.exports = __webpack_public_path__ + "static/media/generic-special.5e2296c2.jpeg";